import { Button, Card, Col, Result, Row } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/logo.webp";


const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="register-wrapper" style={{minHeight : "879px"}}>
      <div className="form-parent">
        <Row justify="center" style={{ width: "100%", marginBottom: 30 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={logo} style={{ width: 300, maxWidth: "100%" }} alt="Logo" />
            </div>
          </Col>
        </Row>
      </div>
      <Card style={{ maxWidth: 500, width: '100%' }}>
        <Result
          status="warning"
          title={<span style={{ color: 'white' }}>Payment Cancelled</span>}
          subTitle={<span style={{ color: 'rgba(255, 255, 255, 0.85)' }}>Your payment was cancelled. Please try again if you wish to complete your purchase.</span>}
          extra={[
            <Button 
              type="primary" 
              key="retry" 
              onClick={() => navigate("/")}
              style={{ 
                backgroundColor: '#f6f233',
                borderColor: '#f6f233',
                color: '#000000'
              }}
            >
              Try Again
            </Button>,
          ]}
        />
      </Card>
    </div>
  );
};

export default PaymentCancel;
